import { Injectable } from '@angular/core';
import { Router } from '@angular/router';

@Injectable({
    providedIn: 'root'
})
export class ErrorHandlerService {

    constructor(private router: Router) { }

    GetErrorMessage(page: string, statusCode: number) {
        var errorMessage;
        switch (statusCode) {
            case 500:
                errorMessage = "Server error occurred. Please contact administrator.";
                break;
            case 201:
                switch (page) {
                    case "Schedule Master":
                        errorMessage = "Schedule Master already exists.";
                        break;
                    case "Task Master":
                        errorMessage = "Task Master already exists.";
                        break;
                    case "Field":
                        errorMessage = "Field already exists.";
                        break;
                    case "User":
                        errorMessage = "User already exists.";
                        break;
                    case "App Configuration":
                        errorMessage = "App Configuration already exists.";
                        break;
                    case "Summary Parameter":
                        errorMessage = "Summary Generation Parameter already exists.";
                        break;
                }

                break;
            case 202:
                switch (page) {
                    case "Login":
                        errorMessage = "Your account has been deactivated, please contact administrator.";
                        break;
                }
                break;
            case 203:
                switch (page) {
                    case "Login":
                        errorMessage = "Not Found.";
                        break;

                }
                break;
            case 225:
                switch (page) {
                    case "ActivityUnit":
                        errorMessage = "";
                        break;
                }
                break;
            case 205:
                switch (page) {
                    case "Login":
                        errorMessage = "Your account is not verified.";
                        break;
                    case "ForgotPassword":
                        errorMessage = "Your account is not verified.";
                        break;
                }
                break;
            case 237:
                switch (page) {
                    case "":
                        errorMessage = "";
                        break;
                }
                break;
            case 211:
                switch (page) {
                    case "Login":
                        errorMessage = "Access denied.";
                        break;
                }
                break;
            case 212:
                switch (page) {
                    case "User":
                        errorMessage = "Invalid file format.";
                        break;
                    case "Workbench":
                        errorMessage = "Invalid file format.";
                        break;
                }
                break;
            case 228:
                switch (page) {
                    case "ForgotPassword":
                        errorMessage = "Your Email Id is not registered.";
                        break;
                    case "Login":
                        errorMessage = "Your Email Id is not registered.";
                        break;
                }
                break;
            case 229:
                switch (page) {
                    case "ResetPassword":
                        errorMessage = "Old Password is incorrect.";
                        break;
                }
                break;
            case 230:
                switch (page) {
                    case "User":
                        errorMessage = "Email Id already exists.";
                        break;
                }
                break;
            case 231:
                switch (page) {
                    case "User":
                        errorMessage = "Phone Number already exists.";
                        break;
                }
                break;
            case 214:
                switch (page) {
                    case "Login":
                        errorMessage = "Your Email Id is not registered.";
                        break;
                }
                break;
            case 216:
                switch (page) {
                    case "Login":
                        errorMessage = "Access denied.";
                        break;
                    case "ForgotPassword":
                        errorMessage = "Access denied.";
                        break;
                }
                break;
            case 241:
                switch (page) {
                }
                break;
            case 244:
                switch (page) {

                }
                break;
            case 400:
                errorMessage = "Bad request.";
                break;
            case 401:
                switch (page) {
                    case "Login":
                        errorMessage = "EmailId or Password is inccorect.";
                        break;
                    case "ForgotPassword":
                        errorMessage = "EmailId is not registered.";
                        break;
                };
                if (page != "Login") {
                    sessionStorage.clear();
                    localStorage.clear();
                    this.router.navigateByUrl("/Login");
                    errorMessage = "Session expired.";
                }
                break;
            case 0:
                errorMessage = "";
                break;
            default:
                errorMessage = "Something went wrong, please try again after some time.";
                break;
        }
        return errorMessage;
    }
}
